import React from "react";
import { Link } from "react-router-dom";
import { ArrowUpRight, Sparkles, MousePointerClick } from "lucide-react";
import { Button } from "@/components/ui/button";
import { SectionContainer, SectionLabel, SectionHeading, SectionLead } from "./SectionPrimitives";

export default function LiveDemo() {
  return (
    <SectionContainer id="live-demo">
      <div className="grid lg:grid-cols-12 gap-10 items-center">
        <div className="lg:col-span-5">
          <SectionLabel number="/ 07" label="Live-Modul" />
          <SectionHeading>Selbst ausprobieren. In 60 Sekunden.</SectionHeading>
          <SectionLead>
            Unser Anzeigen-Simulator zeigt jeden Datensatz live in fünf Google-Formaten —
            inklusive Anzeigenqualitäts-Score. Sie sehen sofort, welche Datenpunkte fehlen
            und wo eine Anreicherung Klick-Reichweite freigibt.
          </SectionLead>

          <ul className="mt-8 space-y-3">
            {[
              { icon: Sparkles, t: "100% Datenqualitäts-Score in Echtzeit" },
              { icon: MousePointerClick, t: "Anzeigen-Vorschau in 5 Formaten" },
              { icon: ArrowUpRight, t: "Direkter Export als PNG für Reportings" },
            ].map(({ icon: Icon, t }) => (
              <li key={t} className="flex items-start gap-3 text-sm text-slate-700">
                <span className="mt-0.5 inline-flex items-center justify-center size-5 rounded-full bg-cyan-50 border border-cyan-200">
                  <Icon className="size-3 text-cyan-600" />
                </span>
                {t}
              </li>
            ))}
          </ul>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <a
              href="https://tools.adsfux.de/vehicleads/"
              target="_blank"
              rel="noreferrer"
              data-testid="livedemo-open-btn"
              data-track="simulator_open"
              data-location="live_demo_section"
              className="w-full sm:w-auto"
            >
              <Button className="inline-flex h-11 w-full items-center justify-center gap-2 rounded-md bg-slate-900 pl-5 pr-4 text-sm text-white hover:bg-slate-800 sm:w-auto">
                Simulator öffnen <ArrowUpRight className="size-4" />
              </Button>
            </a>
            <Link to="/demo" className="w-full sm:w-auto">
              <Button variant="outline" className="h-11 w-full rounded-md border-slate-200 bg-white text-sm text-slate-900 hover:border-slate-300 sm:w-auto">
                Begleitete Demo
              </Button>
            </Link>
          </div>
        </div>

        <div className="lg:col-span-7">
          <div className="relative">
            <div className="absolute -inset-6 bg-gradient-to-br from-cyan-100/40 to-transparent rounded-3xl blur-2xl" aria-hidden />
            <a
              href="https://tools.adsfux.de/vehicleads/"
              target="_blank"
              rel="noreferrer"
              className="relative block bg-white border border-slate-200 rounded-xl ring-soft-lg overflow-hidden group"
            >
              <div className="flex h-9 items-center justify-between border-b border-slate-200 bg-slate-50/60 px-3 sm:px-4">
                <div className="flex items-center gap-1.5">
                  <span className="size-2.5 rounded-full bg-slate-300" />
                  <span className="size-2.5 rounded-full bg-slate-300" />
                  <span className="size-2.5 rounded-full bg-slate-300" />
                </div>
                <div className="hidden font-mono text-[10px] uppercase tracking-[0.2em] text-slate-400 md:block">
                  tools.adsfux.de/vehicleads · simulator · live
                </div>
                <span className="rounded-md border border-emerald-200/80 bg-emerald-50 px-1.5 py-0.5 text-[10px] font-mono uppercase tracking-[0.18em] text-emerald-700">
                  Live
                </span>
              </div>
              <img
                src="/screenshots/04_simulator_desktop.webp"
                alt="Live-Vorschau adsFUX Simulator — Google-SERP-Ansicht"
                className="w-full h-auto block transition-transform duration-700 group-hover:scale-[1.015]"
                loading="lazy"
                decoding="async"
              />
              <div className="absolute inset-0 hidden items-center justify-center bg-slate-900/10 opacity-0 transition-opacity group-hover:opacity-100 sm:flex">
                <span className="inline-flex items-center gap-2 bg-white border border-slate-200 rounded-full px-4 py-2 text-sm font-medium text-slate-900 ring-soft-lg">
                  <ArrowUpRight className="size-4" /> Im Tool öffnen
                </span>
              </div>
            </a>
          </div>
        </div>
      </div>
    </SectionContainer>
  );
}
